import GradingExperiments from 'bundles/epic/clients/Grading';
import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';

/**
 * https://tools.coursera.org/epic/experiment/qsdyVjTDEfCp_w6fFr_gMQ
 *
 * Feature flag to temporary hide work-in-progress on the new Course Frame.
 * @returns true if the Course Frame is enabled.
 */
export const isCourseFrameEnabled = (): boolean => {
  return GradingExperiments.preview('isCourseFrameEnabled') === true;
};

/**
 * https://tools.coursera.org/epic/experiment/vownu3yWEfCAfhJYNo68EQ
 *
 * A/B test to enable time estimates on the course outline.
 * @returns true if time estimates are enabled.
 */
export const isCourseOutlineTimeEstimatesEnabled = (): boolean => {
  return LceCourseExperienceExperiments.get('isCourseOutlineTimeEstimatesEnabled') === true;
};
